require("./bootstrap");

$(function () {
    $('[data-toggle="tooltip"]').tooltip();
});

window.setTimeout(function () {
    $(".alert.calltimer")
        .fadeTo(500, 0)
        .slideUp(500, function () {
            $(this).hide();
        });
}, 4000);

$(function () {
    // $('#data-table').DataTable({
    //     processing: true,
    //     serverSide: false
    // });

    $(".datepicker").datepicker();
});
window.MyNotifyJs = function (html, options) {
    if (typeof html != "undefined") {
        toastr.options = {
            closeButton: false,
            debug: false,
            newestOnTop: false,
            progressBar: false,
            positionClass: "toast-top-right",
            preventDuplicates: true,
            onclick: null,
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "5000",
            extendedTimeOut: "1000",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut",

            // tapToDismiss : true,
            // timeOut: 0,
            // extendedTimeOut: 0,
        };
        toastr[options.type](html);
    }
    return;
};
if ($(".select2jsTagInput").length > 0) {
    $(".select2jsTagInput").tagsinput({
        tagClass: "badge badge-info",
    });
}

if ($(".mySelect2").length > 0) {
    $(".mySelect2").select2({ width: "100%" });
}

$(document).ready(function () {
    /* site manager page */
    if ($("#toggle_field").length > 0) {
        $("#toggle_field").change(function () {
            var value = $(this).val();
            $(
                ".toggle-ads-image, .toggle-ads-video, .toggle-ads-youtube",
            ).hide();
            if (value === "image") {
                $(".toggle-ads-image").show();
            } else if (value === "video") {
                $(".toggle-ads-video").show();
            } else if (value === "youtube") {
                $(".toggle-ads-youtube").show();
            }
        });
        // Trigger change event on page load to set initial state
        $("#toggle_field").trigger("change");
    }

    if ($("#selecctall").length > 0) {
        $("#selecctall").click(function (event) {
            if (this.checked) {
                $(".checkCK_id").each(function () {
                    this.checked = true;
                });
            } else {
                $(".checkCK_id").each(function () {
                    this.checked = false;
                });
            }
        });
    }
});

$.ajaxSetup({
    headers: {
        "X-CSRF-TOKEN": $('meta[name="site_csrf_token"]').attr("content"),
    },
});

window.initializeSelect2AjaxSearchField = function (targetField, Url) {
    $(targetField).select2({
        ajax: {
            url: Url,
            dataType: "json",
            delay: 250,
            type: "post",
            data: function (params) {
                return {
                    search: params.term,
                };
            },
            processResults: function (response) {
                var results = [];
                $.each(response, function (index, return_data) {
                    results.push({ id: index, text: return_data });
                });
                return {
                    results: results,
                };
            },
            cache: true,
        },
        placeholder: "Write Something",
        minimumInputLength: 3,
    });
};

$(document).on("click", ".remove-comm-parent", function (event) {
    $(this).parents($(this).data("target")).remove();
});

$(document).on("click", ".add-comm-parent", function (event) {
    var clone_to_target = $($(this).data("append"));
    var clone_target = $($(this).data("clone"));
    if (clone_target) {
        clone_to_target.append(clone_target.clone());
    }
});

$(".ajaxCall").on("change", function (e) {
    e.preventDefault();
    fetchData(this);
});

window.fetchData = function (obj) {
    var targetId = $(obj).data("target");
    var ajaxUrl = $(obj).data("action");
    var data = $(obj).val();
    var html = "";
    $.ajax({
        type: "post",
        url: ajaxUrl,
        data: { id: data },
        success: function (data) {
            if ($("#" + targetId).hasClass("select2js")) {
                $("#" + targetId)
                    .html("")
                    .select2({
                        width: "100%",
                        containerCssClass: "select2js select2js-form-control",
                    });
                $("#" + targetId).html(data);
                $("#" + targetId).select2("open");
            } else {
                $("#" + targetId).html(data);
            }
        },
    });
};

$("#change-dark-mode").on("change", function () {
    var is_checked = false;
    var ajaxUrl = $(this).data("action");
    if (this.checked) {
        is_checked = true;
    }
    $.ajax({
        type: "get",
        url: ajaxUrl,
        dataType: "json",
        data: { mode: is_checked },
        success: function (data) {
            if (data.status) {
                if (data.mode) {
                    $("#toggle-dark-mode-head").addClass("dark-mode");
                    $("#toggle-dark-mode-nav").removeClass(
                        "navbar-light navbar-white",
                    );
                    $("#toggle-dark-mode-nav").addClass(
                        "navbar-dark navbar-dark",
                    );
                } else {
                    $("#toggle-dark-mode-head").removeClass("dark-mode");
                    $("#toggle-dark-mode-nav").addClass(
                        "navbar-light navbar-white",
                    );
                    $("#toggle-dark-mode-nav").removeClass(
                        "dark-mode navbar-dark",
                    );
                }
            } else {
                console.log("something went wrong");
            }
        },
    });
});

$(document).on("dblclick", ".show-panel", function () {
    $($(this).data("target")).removeClass("d-none");
});

$(document).on("click", ".ajax-delete-record", function () {
    let that = $(this);
    var url = that.data("url");
    var target = that.data("target");
    if (confirm("Are you sure you want to delete?")) {
        $.ajax({
            url: url,
            method: "get",
            success: function (response) {
                if (response.success) {
                    $(target).remove();
                    MyNotifyJs(response.message, { type: "success" });
                } else {
                    MyNotifyJs(response.message, { type: "error" });
                }
            },
            error: function (xhr) {
                MyNotifyJs(xhr.responseJSON.message, { type: "error" });
            },
        });
    }
});

window.initializeSelect2AjaxSearchField = function (targetField, Url) {
    $(targetField).select2({
        ajax: {
            url: Url,
            dataType: "json",
            delay: 250,
            type: "post",
            data: function (params) {
                return {
                    search: params.term,
                };
            },
            processResults: function (response) {
                var results = [];
                $.each(response, function (index, return_data) {
                    results.push({ id: index, text: return_data });
                });
                return {
                    results: results,
                };
            },
            cache: true,
        },
        placeholder: "Write Something",
        minimumInputLength: 3,
    });
};

window.UpdateBBPSService = function (obj) {
    let value = $(obj).val().split("-");
    if (value.length == 2) {
        $.ajax({
            url: bbps_ajax_url,
            data: {
                flag: value[0],
                key: value[1],
            },
            method: "post",
            dataType: "json",
            success: function (response) {
                if (response.status) {
                    MyNotifyJs("Request Update successfully", {
                        type: "success",
                    });
                } else {
                    MyNotifyJs(response.message, { type: "error" });
                    setTimeout(function () {
                        window.location.reload();
                    }, 3000);
                }
            },
        });
    }
};

$(document).ready(function () {
    const dateInput = $("#dateInput");
    const dateDisplay = $("#dateDisplay");
    const dateForm = $("#dateForm");

    function formatToDMY(dateString) {
        if (!dateString) return "";
        const parts = dateString.split("-");
        return parts.length === 3
            ? `${parts[2]}-${parts[1]}-${parts[0]}`
            : dateString;
    }

    function formatToYMD(dateString) {
        if (!dateString) return "";
        const parts = dateString.split("-");
        return parts.length === 3
            ? `${parts[2]}-${parts[1]}-${parts[0]}`
            : dateString;
    }

    dateDisplay.val(formatToDMY(dateInput.val()));

    dateDisplay.datepicker({
        dateFormat: "dd-mm-yy",
        changeMonth: true,
        changeYear: true,
        onSelect: function (dateText, inst) {
            dateInput.val(formatToYMD(dateText));
            dateForm.submit();
        },
    });

    dateDisplay.on("change", function () {
        dateInput.val(formatToYMD(dateDisplay.val()));
        dateForm.submit();
    });

    function changeDate(days) {
        let currentDate = dateInput.val()
            ? new Date(dateInput.val() + "T00:00:00")
            : new Date();

        currentDate.setDate(currentDate.getDate() + days);

        const newYMD = $.datepicker.formatDate("yy-mm-dd", currentDate);

        dateInput.val(newYMD);
        dateDisplay.val(formatToDMY(newYMD));

        dateForm.submit();
    }

    $("#prevDate").on("click", function () {
        changeDate(-1);
    });

    $("#nextDate").on("click", function () {
        changeDate(1);
    });

    $("#filterToggle").on("click", function () {
        $("#filter-posts").toggleClass("d-none");
    });

    $("#filterClose").on("click", function () {
        $("#filter-posts").addClass("d-none");
    });

    $(document).on("click", function (e) {
        if (
            !$(e.target).closest(".filter-panel").length &&
            !$("#filter-posts").hasClass("d-none")
        ) {
            $("#filter-posts").addClass("d-none");
        }
    });
});

window.submitFrm = function (frmObj, redirectUrl = "") {
    frmUrl = $(frmObj).attr("action");
    var frmData = new FormData($(frmObj)[0]);
    var frmId = $(frmObj).attr("id");
    let model_obj = $("#site-model");
    $.ajax({
        method: "post",
        url: frmUrl,
        data: frmData,
        dataType: "json",
        beforeSend: function () {
            model_obj.find(".modal-loader").show();
            model_obj.find(".modal-error").empty();
        },
        complete: function () {
            model_obj.find(".modal-loader").show();
            model_obj.find(".modal-loader").hide();
        },
        success: function (json_array) {
            if (json_array.status) {
                if (json_array.action == "redirect") {
                    setInterval(function () {
                        window.location.href = json_array.url;
                    }, 2000);
                }
                if (json_array.action == "show-model") {
                    openPopup(json_array.url);
                }
                if (json_array.action == "show-model-refresh") {
                    model_obj
                        .modal("show")
                        .find(".modal-body")
                        .html(json_array.message);
                    setTimeout(function () {
                        // location.reload();
                    }, 5000);
                }
                if (json_array.action == "show-model-redirect") {
                    model_obj
                        .modal("show")
                        .find(".modal-body")
                        .html(json_array.message);
                    setTimeout(function () {
                        window.location.href = json_array.url;
                    }, 5000);
                }
                if (json_array.action == "showError") {
                    var errors = json_array["errors"];
                    if (typeof errors == "object") {
                        $.each(errors, function (key, value) {
                            if (value) {
                                MyNotifyJs(value, { type: "error" });
                            }
                        });
                    } else if (typeof errors == "string") {
                        MyNotifyJs(errors, { type: "error" });
                    }
                }
                if (json_array.action == "reload") {
                    window.location.reload();
                }
                if (json_array.action == "notify") {
                    MyNotifyJs(json_array.message, { type: "error" });
                }
                if (json_array.action == "notify-success") {
                    MyNotifyJs(json_array.message, { type: "success" });
                }
            } else {
                window.location.reload();
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            model_obj.find(".modal-loader").hide();
            if (jqXHR.responseText) {
                var errorResponse = JSON.parse(jqXHR.responseText);
                var errors = errorResponse["errors"];
                if (typeof errors == "object") {
                    $.each(errors, function (key, value) {
                        if (value) {
                            MyNotifyJs(value, { type: "error" });
                        }
                    });
                } else if (typeof errors == "string") {
                    MyNotifyJs(errors, { type: "error" });
                }
            }
        },
        cache: false,
        contentType: false,
        processData: false,
    });
    return false;
};

window.openPopup = function (popupUrl, formId = "", modalWidth = "") {
    $("#site-model").find(".modal-error").html(" ");
    $("#site-model").find(".ContentDiv").html(" ");
    $("#site-model").find(".modal-loader").show();
    $("#site-model")
        .find(".modal-dialog modal-dialog-centered")
        .removeClass()
        .addClass("modal-dialog");

    var token = $('meta[name="site_csrf_token"]').attr("content");
    var formData = { _token: token };
    if (formId) {
        formData = $("#" + formId).serialize();
    }
    $.ajax({
        method: formId ? "post" : "get",
        url: popupUrl,
        data: formData,
        dataType: "json",
        success: function (json_array) {
            if (json_array.status) {
                if (modalWidth) {
                    $("#site-model")
                        .find(".modal-dialog")
                        .removeClass("modal-lg");
                    $("#site-model").find(".modal-dialog").addClass(modalWidth);
                }
                $("#site-model").find(".modal-loader").hide();
                $("#site-model")
                    .modal("show")
                    .find(".ContentDiv")
                    .html(json_array.html);
            } else {
                MyNotifyJs(json_array.message, { type: "error" });
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            $("#site-model").find(".modal-loader").hide();
            if (jqXHR.responseJSON) {
                MyNotifyJs(jqXHR.responseJSON.message, { type: "error" });
            }
        },
    });
};

/* E comm product module */
$(document).on("click", ".toggle-appearance", function () {
    let that = $(this);
    if ($(this).is(":checked")) {
        $(that.data("target")).removeClass("d-none");
    } else {
        $(that.data("target")).addClass("d-none");
    }
});

// https://codepen.io/monbrielle/pen/dyYRgPm
// https://stackoverflow.com/questions/19301863/how-to-make-ajax-synchronous
$(document).ready(function () {
    var current_fs, next_fs, previous_fs;
    var p_form_opacity;
    var current = 1;
    var steps = $("fieldset").length;

    $(".next").click(function () {
        // for (instance in CKEDITOR.instances) {
        //     CKEDITOR.instances[instance].updateElement();
        // }
        var frmData = new FormData($("#msform")[0]);
        var current_fs = $(this).parents("fieldset");
        var next_fs = $(this).parents("fieldset").next();
        var _step = $(this).data("step");
        frmData.append("_step", _step);
        frmUrl = $("#msform").attr("action");
        $.ajax({
            method: "post",
            url: $("#msform").attr("action"),
            data: frmData,
            dataType: "json",
            beforeSend: function () {
                $("#form-loader").show();
            },
            complete: function () {
                $("#form-loader").hide();
            },
            success: function (json_array) {
                if (json_array.status) {
                    /* Hashing URL */
                    if (_step == "basic") {
                        $("#target_product_id").val(json_array.product.id);
                        let stateObj = {
                            product: json_array.product,
                            _step: _step,
                        };
                        if (history.pushState) {
                            window.history.pushState(
                                stateObj,
                                json_array.product.name,
                                json_array.product.edit_url,
                            );
                        } else {
                            window.history.replaceState(
                                stateObj,
                                json_array.product.name,
                                json_array.product.edit_url,
                            );
                            document.title = json_array.product.name;
                        }
                    }

                    if (json_array.step == "seo") {
                        $("#site-model")
                            .modal("show")
                            .find(".modal-body")
                            .html(json_array.html);
                        return;
                    }

                    $("#progressbar li")
                        .eq($("fieldset").index(next_fs))
                        .addClass("active");
                    next_fs.show();
                    current_fs.animate(
                        {
                            p_form_opacity: 0,
                        },
                        {
                            step: function (now) {
                                p_form_opacity = 1 - now;
                                current_fs.css({
                                    display: "none",
                                    position: "relative",
                                });
                                next_fs.css({
                                    opacity: p_form_opacity,
                                });
                            },
                            duration: 500,
                        },
                    );
                } else if (json_array.status == false) {
                    MyNotifyJs(json_array.message, { type: "error" });
                } else {
                    window.location.reload();
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                $("#form-loader").show();
                $("#form-loader").hide();
                if (jqXHR.responseText) {
                    var errorResponse = JSON.parse(jqXHR.responseText);
                    var errors = errorResponse["errors"];
                    if (typeof errors == "object") {
                        $.each(errors, function (key, value) {
                            if (value) {
                                MyNotifyJs(value, { type: "error" });
                            }
                        });
                    } else if (typeof errors == "string") {
                        MyNotifyJs(errors, { type: "error" });
                    }
                }
            },
            cache: false,
            contentType: false,
            processData: false,
        });
        return false;
    });

    $(".previous").click(function () {
        current_fs = $(this).parents("fieldset");
        previous_fs = $(this).parents("fieldset").prev();
        //Remove class active
        $("#progressbar li")
            .eq($("fieldset").index(current_fs))
            .removeClass("active");
        //show the previous fieldset
        previous_fs.show();
        //hide the current fieldset with style
        current_fs.animate(
            {
                p_form_opacity: 0,
            },
            {
                step: function (now) {
                    p_form_opacity = 1 - now;
                    current_fs.css({
                        display: "none",
                        position: "relative",
                    });
                    previous_fs.css({
                        opacity: p_form_opacity,
                    });
                },
                duration: 500,
            },
        );
    });
});

$(document).on("click", ".remove-product-variant", function () {
    let that = $(this);
    if (confirm("Do you want to remove this Variant?") == false) {
        return;
    }
    $.ajax({
        method: "get",
        url: that.data("route"),
        dataType: "json",
        success: function (json_array) {
            if (json_array.status) {
                MyNotifyJs(json_array.message, { type: "success" });
                $(that.data("target")).remove();
            } else {
                MyNotifyJs(json_array.message, { type: "error" });
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.responseJSON) {
                MyNotifyJs(jqXHR.responseJSON.message, { type: "error" });
            }
        },
    });
});

/* image module */
window.renderMediaOnDiv = function (input) {
    if (input.files && input.files[0]) {
        if (!/\.(jpe?g|png|gif)$/i.test(input.files[0].name)) {
            return alert(input.files[0].name + " is not an image");
        }
        var reader = new FileReader();
        reader.onload = function (event) {
            var parent_target = $(input).data("parent");
            $(parent_target).css(
                "background",
                "url(" + event.target.result + ")",
            );
            $(parent_target).addClass("active");
        };
        reader.readAsDataURL(input.files[0]);
    }
};

$(document).on("click", ".add-img", function () {
    var text = $(this).data("name");
    var value = $(this).data("value");

    if ($(this).prop("checked") == true) {
        append_image(text, value);
    } else {
        remove_content(value);
    }

    function remove_content(value) {
        var iDiv = $("#image-append");
        let parent_id = "#parent_" + value + "_main";
        iDiv.find(parent_id).remove();
    }

    function append_image(text, value) {
        var iDiv = $("#image-append");

        let parent_id = "parent_" + value;
        let event_location = "parent_target_" + value;

        var div_parent = document.createElement("div");
        div_parent.className = "mr-3 media_parent_div";
        div_parent.id = parent_id + "_main";

        var child_label = document.createElement("label");
        child_label.className = "datakart_img parant_img_div";
        child_label.id = parent_id;
        child_label.setAttribute("data-name", value);
        child_label.setAttribute("for", event_location);

        var child_heading = document.createElement("span");
        child_heading.appendChild(
            document.createTextNode("Select " + text + " Image"),
        );
        child_heading.classList = "datakart_img_heading";

        var child_close = document.createElement("span");
        child_close.appendChild(document.createTextNode("X"));
        child_close.classList = "datakart_img_close";
        child_close.setAttribute("data-parent", "#" + parent_id);
        child_close.setAttribute("data-value", value);

        var upload_input = document.createElement("INPUT");
        ((upload_input.type = "file"),
            // upload_input.name        = "images["+value+"]";
            (upload_input.name = value));
        upload_input.classList = "d-none";
        ((upload_input.style = "display:none"),
            (upload_input.id = event_location),
            upload_input.setAttribute("data-parent", "#" + parent_id));
        upload_input.setAttribute("onchange", "renderMediaOnDiv(this)");

        child_label.append(upload_input, child_heading);
        div_parent.append(child_label, child_close);
        iDiv.append(div_parent);
    }
});

window.UpdateProductModule = function (frmObj, append_html = "") {
    frmUrl = $(frmObj).attr("action");
    var frmData = new FormData($(frmObj)[0]);
    var frmId = $(frmObj).attr("id");
    $.ajax({
        method: "post",
        url: frmUrl,
        data: frmData,
        dataType: "json",
        beforeSend: function () {
            $("#site-model").find(".modal-loader").show();
        },
        complete: function () {
            $("#site-model").find(".modal-loader").hide();
        },
        success: function (json_array) {
            if (json_array.status) {
                $(append_html).empty();
                $(append_html).append(json_array.html);
                $("#site-model").modal("hide");
                if (json_array.has_error) {
                    MyNotifyJs("Some media not update", { type: "error" });
                }
            } else {
                MyNotifyJs(json_array.message, { type: "error" });
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            $("#site-model").find(".modal-loader").hide();
            if (jqXHR.responseText) {
                var errorResponse = JSON.parse(jqXHR.responseText);
                var errors = errorResponse["errors"];
                if (typeof errors == "object") {
                    $.each(errors, function (key, value) {
                        if (value) {
                            MyNotifyJs(value, { type: "error" });
                        }
                    });
                } else if (typeof errors == "string") {
                    MyNotifyJs(errors, { type: "error" });
                }
            }
        },
        cache: false,
        contentType: false,
        processData: false,
    });
    return false;
};

$(document).on("click", ".datakart_img_close", function () {
    let that = $(this);
    let parent_id = that.data("parent");
    let value = that.data("value");
    $("#datakart_image_" + value + "_label").trigger("click");
    $("#parent_" + value + "_main").remove();
});

$(document).on("click", "#append-save-media .save-product-cover", function () {
    let that = $(this);
    let target_media = that.data("target");
    $.ajax({
        method: "post",
        url: that.data("url"),
        dataType: "json",
        beforeSend: function () {
            $("#form-loader").show();
        },
        complete: function () {
            $("#form-loader").hide();
        },
        success: function (json_array) {
            if (json_array.status) {
                $("#append-save-media").empty();
                $("#append-save-media").append(json_array.html);
            } else {
                MyNotifyJs(json_array.message, { type: "error" });
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.responseText) {
                var errorResponse = JSON.parse(jqXHR.responseText);
                var errors = errorResponse["errors"];
                if (typeof errors == "object") {
                    $.each(errors, function (key, value) {
                        if (value) {
                            MyNotifyJs(value, { type: "error" });
                        }
                    });
                } else if (typeof errors == "string") {
                    MyNotifyJs(errors, { type: "error" });
                }
            }
        },
    });
});

$(document).on("click", ".view-product-options", function () {
    let that = $(this);
    let target_div = that.data("target");
    $(".attribute_options_div").addClass("d-none");
    $(target_div).removeClass("d-none");
});

$(document).on("click", ".remove-parent-self", function () {
    $($(this)).parents($(this).data("target")).remove();
});

$(document).on("click", ".clone-parent-self", function () {
    let that = $(this);
    let target = that.data("append-target");
    let clone_target = that.data("clone-target");
    if ($(this).is(":checked")) {
        let clone_html = $(clone_target).clone();
        clone_html.find(".at-checkbox").remove();
        $(target).append(clone_html);
    } else {
        $(target).find(clone_target).remove();
    }
});

$(document).on("click", ".toggle-product-stock", function () {
    let that = $(this);
    if ($(this).is(":checked")) {
        $("#master-inventory").addClass("d-none");
        $("#master-attribute-inventory").removeClass("d-none");
    } else {
        $("#master-inventory").removeClass("d-none");
        $("#master-attribute-inventory").addClass("d-none");
    }
});

/* End E comm product module */

$(document).on("change", ".upload-single-image", function () {
    targetId = $(this).data("id");
    readURLSingle(this, targetId);
});

window.checkContentType = function (e) {
    let type = $(e).data("type");
    let error = $(e).data("error");
    $(error).html("");
    if (type == "doc" && !/\.(pdf|doc|docx)$/i.test(e.files[0].name)) {
        // var text = '<div class="text-danger"> ' + e.files[0].name + ' is not an Document (pdf ,doc ,docx )</div>';
        var text = "Please select valid document format (pdf ,doc ,docx )";
        MyNotifyJs(text, { type: "error" });
        $(error).html(text);
        return false;
    }
    if (type == "video" && !/\.(mp4|avi)$/i.test(e.files[0].name)) {
        // var text = '<div class="text-danger"> ' + e.files[0].name + ' is not valid video (jmp4,avi)</div>';
        var text = "Please select valid video format (mp4,avi)";
        MyNotifyJs(text, { type: "error" });
        $(error).html(text);
        return false;
    }
    if (type == "image" && !/\.(jpe?g|png|gif|webp)$/i.test(e.files[0].name)) {
        // var text = '<div class="text-danger"> ' + e.files[0].name + ' is not valid Image (jpe,jpeg,png)</div>';
        var text = "Please select valid Image format (jpe,jpeg,png,webp)";
        MyNotifyJs(text, { type: "error" });
        $(error).html(text);
        return false;
    }
    if (type == "image" && e.files[0].size > 2000000) {
        // var text = '<div class="text-danger"> ' + e.files[0].name + ' Image is too large</div>';
        var text = "Upload image max size 2MB";
        MyNotifyJs(text, { type: "error" });
        $(error).html(text);
        return false;
    }
    if (type == "video" && e.files[0].size > 10000000) {
        // var text = '<div class="text-danger"> ' + e.files[0].name + ' Image is too large</div>';
        var text = "Upload video max size 2MB";
        MyNotifyJs(text, { type: "error" });
        $(error).html(text);
        return false;
    }
    return true;
};

$(document).on("change", ".upload-single", function () {
    targetId = $(this).data("id");
    if (checkContentType(this)) {
        readURLSingle(this, targetId);
    } else {
        $(targetId).attr("src", "");
        $(this).val("");
    }
});

window.readURLSingle = function (e, t) {
    if (e.files && e.files[0]) {
        var a = new FileReader();
        ((a.onload = function (e) {
            $(t).attr("src", e.target.result);
        }),
            a.readAsDataURL(e.files[0]));
    }
};

window.previewImages = function () {
    var preview = document.querySelector("#productImg");
    $("#productImg").empty();
    if (this.files) {
        [].forEach.call(this.files, readAndPreview);
    }
    window.readAndPreview = function (file) {
        if (!/\.(jpe?g|png|gif)$/i.test(file.name)) {
            return alert(file.name + " is not an image");
        }
        var reader = new FileReader();
        reader.addEventListener("load", function () {
            var image = new Image();
            image.height = 100;
            image.title = "Remove Image";
            image.src = this.result;
            image.classList = "removeImage";
            image.name = "image[]";
            preview.appendChild(image);
        });
        reader.readAsDataURL(file);
    };
};

$(document).on("change", ".upload-multi", previewImages);
window.readURLSec = function (input) {
    if (input.files && input.files[0]) {
        if (!/\.(jpe?g|png|gif)$/i.test(input.files[0].name)) {
            return alert(input.files[0].name + " is not an image");
        }
        var reader = new FileReader();
        reader.onload = function (event) {
            var className = $(input).attr("class");
            $(".images").prepend(
                '<div id="imageRemoveId" class="' +
                    className +
                    '" style="background-image: url(\'' +
                    event.target.result +
                    '\');" rel="' +
                    event.target.result +
                    '"><span>remove</span></div>',
            );
            $(".image-title").html(input.files[0].name);
        };
        reader.readAsDataURL(input.files[0]);
        // } else {
        //     removeUpload();
    }
};
$(document).ready(function () {
    // uploadImage();
    window.uploadImage = function () {
        var button = $(".images .pic");
        var images = $(".images");

        function setAttributes(elem, attrs) {
            for (var key in attrs) {
                elem.setAttribute(key, attrs[key]);
            }
        }
        button.on("click", function () {
            var classValue = Math.random().toString(36).substring(7);
            var elem = document.createElement("INPUT");
            setAttributes(elem, {
                type: "file",
                class: classValue,
                name: "image[]",
                style: "display:none",
                onchange: "readURLSec(this);",
            });
            document
                .getElementById("productImg")
                .setAttribute("class", "d-none");
            document.getElementById("uploadImage").appendChild(elem);
            elem.click();
        });
        images.on("click", "#imageRemoveId", function () {
            var className = $(this).attr("class");
            $("." + className).remove();
        });
    };
    uploadImage();
});

class Pushbar {
    constructor(config = { overlay: true, blur: false }) {
        this.current = null;
        this.overlay = false;
        if ("overlay" in config) {
            if (config.overlay) {
                this.overlay = document.createElement("div");
                this.overlay.classList.add("pushbar_overlay");
                this.select("body").appendChild(this.overlay);
            }
        }
        if ("blur" in config) {
            if (config.blur) {
                var main_content = document.querySelector(
                    ".pushbar_main_content",
                );
                if (main_content) {
                    main_content.classList.add("pushbar_blur");
                }
            }
        }
        this.bindEvents();
    }
    bindEvents() {
        var triggers = document.querySelectorAll("[data-pushbar-target]");
        var closers = document.querySelectorAll("[data-pushbar-close]");
        var self = this;
        if (triggers) {
            for (var i = 0; i < triggers.length; i++) {
                triggers[i].addEventListener(
                    "click",
                    function (e) {
                        e.preventDefault();
                        var pushbar_id = this.getAttribute(
                            "data-pushbar-target",
                        );
                        if (pushbar_id) {
                            self.open(pushbar_id);
                        }
                    },
                    false,
                );
            }
        }
        if (closers) {
            for (var i = 0; i < closers.length; i++) {
                closers[i].addEventListener(
                    "click",
                    function (e) {
                        e.preventDefault();
                        self.close();
                    },
                    false,
                );
            }
        }
        if (this.overlay) {
            this.overlay.addEventListener(
                "click",
                function (e) {
                    e.preventDefault();
                    self.close();
                },
                false,
            );
        }
        document.addEventListener("keyup", function (e) {
            if (self.current && e.keyCode == 27) {
                self.close();
            }
        });
    }
    select(selector) {
        return document.querySelector(selector);
    }
    opening(pushbar) {
        if (pushbar) {
            var event = new CustomEvent("pushbar_opening", {
                bubbles: true,
                detail: { pushbar: pushbar },
            });
            pushbar.dispatchEvent(event);
        }
    }
    closing(pushbar) {
        if (pushbar) {
            var event = new CustomEvent("pushbar_closing", {
                bubbles: true,
                detail: { pushbar: pushbar },
            });
            pushbar.dispatchEvent(event);
        }
    }
    add(pushbar) {
        var pushbar_id = this.getId(pushbar);
        this.current = pushbar_id;
    }
    remove(pushbar) {
        this.current = null;
    }
    current() {
        return this.current;
    }
    find(pushbar_id) {
        var pushbar = this.select('[data-pushbar-id="' + pushbar_id + '"]');
        return pushbar;
    }
    getPushbar(pushbar) {
        if (pushbar instanceof HTMLElement) {
            return pushbar;
        } else {
            return this.find(pushbar);
        }
    }
    getId(pushbar) {
        if (pushbar instanceof HTMLElement) {
            return pushbar.getAttribute("data-pushbar-id");
        } else {
            return pushbar;
        }
    }
    open(pushbar) {
        var pushbar_id = this.getId(pushbar);
        var pushbar = this.getPushbar(pushbar);
        if (pushbar) {
            this.close();
            this.opening(pushbar);
            pushbar.classList.add("opened");
            this.select("html").classList.add("pushbar_locked");
            this.select("html").setAttribute("pushbar", pushbar_id);
            this.add(pushbar_id);
        }
    }
    close() {
        var pushbar = this.select("[data-pushbar-id].opened");
        if (pushbar) {
            this.closing(pushbar);
            pushbar.classList.remove("opened");
            this.select("html").classList.remove("pushbar_locked");
            this.select("html").removeAttribute("pushbar");
        }
        this.remove();
    }
}

window.openPushBar = function (
    popupUrl,
    target_type = "left",
    formId = "",
    size = "",
) {
    let target_slider = $(".from_" + target_type);
    if (target_slider.length == 0) {
        MyNotifyJs("Invalid Push Bar Env", { type: "error" });
        return;
    }
    target_slider.find(".modal-error").html(" ");
    target_slider.find(".pushbar-content").html(" ");
    target_slider.find(".pushbar-loader").show();
    var token = $('meta[name="site_csrf_token"]').attr("content");
    var formData = { _token: token };
    if (formId) {
        formData = $("#" + formId).serialize();
    }
    $.ajax({
        method: formId ? "post" : "get",
        url: popupUrl,
        data: formData,
        success: function (data) {
            if (data.status) {
                target_slider.find(".pushbar-loader").hide();
                target_slider.find(".pushbar-content").html(data.html);
                if (size) {
                    if (target_type == "left" || target_type == "right") {
                        target_slider.css({ width: size });
                    } else {
                        target_slider.css({ height: size });
                    }
                }
                let push_bar_obj = new Pushbar({ blur: true, overlay: true });
                push_bar_obj.open(target_type);
            } else {
                MyNotifyJs(data.message, { type: "error" });
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.responseJSON) {
                MyNotifyJs(jqXHR.responseJSON.message, { type: "error" });
            }
        },
    });
};
document.addEventListener("click", function (e) {
    if (e.target.classList.contains("event-time")) {
        e.target.showPicker();
    }
});

$(document).on("click", ".ceremony_like_li", function () {
    let parent = $(this);
    let icon = parent.find(".like_icon");
    let ceremony_id = parent.data("id");
    let url = parent.data("like-url");

    $.ajax({
        url: url,
        type: "POST",
        data: {
            _token: document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute("content"),
        },
        success: function (res) {
            icon.css("color", res.liked ? "red" : "gray");
            parent.find(".like_count").text(res.count);
        },
        error: function (xhr) {
            if (xhr.status === 401) {
                toastr.error("Please login to like this ceremony!");
            } else {
                toastr.error("Something went wrong!");
            }
        },
    });
});

// $(document).on("click", ".ceremony_share_li", function () {
//     let title = $(this).data("title");
//     let url = $(this).data("url");

//     if (navigator.share) {
//         navigator
//             .share({
//                 title: title,
//                 url: url,
//             })
//             .then(() => {
//                 console.log("Thanks for sharing!");
//             })
//             .catch((err) => {
//                 console.error(err);
//             });
//     } else {
//         // Fallback: copy link
//         navigator.clipboard
//             .writeText(url)
//             .then(() => {
//                 toastr.success("Link copied to clipboard!");
//             })
//             .catch(() => {
//                 toastr.error("Could not copy link.");
//             });
//     }
// });

function isMobileOrTablet() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent) ||
        (navigator.maxTouchPoints && navigator.maxTouchPoints > 1);
}

$(document).on("click", ".ceremony_share_li", async function () {
    let title = $(this).data("title");
    let name = $(this).data("name");
    let url = $(this).data("url");
    let mediaUrl = $(this).data("media");
    let mobileOrTablet = isMobileOrTablet();

    try {
        if (!mobileOrTablet) {
            await navigator.clipboard.writeText(url);
            toastr.success("Link copied!");
            return;
        }

        let shareText = `${title ? title + "\n" : ""}${name ? name + "\n" : ""}${url}`;
        let shareData = {
            title: shareText,
            text: shareText,
            url: url
        };

        let imageFile = null;
        if (mediaUrl) {
            try {
                const response = await fetch(mediaUrl, { mode: "cors" });
                if (response.ok) {
                    const contentType = response.headers.get("content-type");
                    if (contentType && contentType.startsWith("image/")) {
                        const blob = await response.blob();
                        if (blob.size > 0) {
                            const extension = contentType.split("/")[1];
                            const fileName = `image.${extension}`;
                            imageFile = new File([blob], fileName, {
                                type: contentType,
                            });
                        }
                    }
                }
            } catch (mediaError) {
                // console.warn("Image fetch failed, will share without image", mediaError);
            }
        }

        if (navigator.share) {
            try {
                if (imageFile) {
                    shareData.files = [imageFile];
                    if (navigator.canShare && navigator.canShare(shareData)) {
                        await navigator.share(shareData);
                        return;
                    }
                }
                delete shareData.files;
                await navigator.share(shareData);
            } catch (shareError) {
                if (shareError.name !== 'AbortError') {
                    await navigator.clipboard.writeText(url);
                    toastr.success("Link copied!");
                }
            }
        } else {
            // Fallback: clipboard
            await navigator.clipboard.writeText(url);
            toastr.success("Link copied!");
        }
    } catch (err) {
        try {
            await navigator.clipboard.writeText(url);
            toastr.success("Link copied!");
        } catch {
            toastr.error("Could not share or copy link");
        }
    }
});


const pickerWrapper = document.getElementById("openDate");
if (pickerWrapper) {
    const dateInput = document.getElementById("headerDateInput");
    const hiddenField = document.getElementById("hiddenDateField");
    const displayText = document.getElementById("headerDateText");

    if (dateInput && hiddenField && displayText) {
        pickerWrapper.addEventListener("click", () => {
            dateInput.showPicker(); // open the date picker
        });

        dateInput.addEventListener("change", function () {
            const date = new Date(this.value);
            if (isNaN(date)) return;

            const day = date.getDate();
            const month = date.toLocaleString("default", {
                month: "long",
            });
            const year = date.getFullYear();

            let suffix = "th";
            if ([1, 21, 31].includes(day)) suffix = "st";
            else if ([2, 22].includes(day)) suffix = "nd";
            else if ([3, 23].includes(day)) suffix = "rd";

            displayText.innerText = `${day}${suffix} ${month}, ${year}`;

            hiddenField.value = this.value;

            const dateForm = document.getElementById("dateForm");
            if (dateForm) dateForm.submit();
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".clickable-card").forEach((card) => {
        card.addEventListener("click", function (e) {
            if (
                e.target.closest(
                    ".footer-card, .interaction-bar, a, button, .ceremony_like_li, .ceremony_comment_li, .ceremony_share_li, .ceremony_report_li",
                )
            ) {
                return;
            }

            const url = this.dataset.url;
            if (url) window.location.href = url;
        });
    });
});

$("#bg_image_selector").click(() => $("#banner_input").click());
$("#profile_pic_selector").click(() => $("#profile_input").click());

$("#banner_input").change(function (e) {
    const reader = new FileReader();
    reader.onload = function (event) {
        $("#bg_image").attr("src", event.target.result);
    };
    reader.readAsDataURL(e.target.files[0]);
});

$("#profile_input").change(function (e) {
    const reader = new FileReader();
    reader.onload = function (event) {
        $("#profile_photo").attr("src", event.target.result);
    };
    reader.readAsDataURL(e.target.files[0]);
});

let ceremonyLoading = false;
window.addEventListener("scroll", function () {
    if (ceremonyLoading) return;

    let nextPageUrlElem = document.getElementById("next_page_url");
    let loadingElem = document.getElementById("loading");

    if (nextPageUrlElem && loadingElem) {
        if (
            window.innerHeight + window.scrollY >=
            document.body.offsetHeight - 150
        ) {
            let nextPage = nextPageUrlElem.value;
            if (nextPage) {
                ceremonyLoading = true;
                loadingElem.style.display = "block";
                fetch(nextPage)
                    .then((res) => res.text())
                    .then((data) => {
                        let parser = new DOMParser();
                        let html = parser.parseFromString(data, "text/html");
                        let container = html.querySelector(
                            "#ceremony-container",
                        );

                        if (container) {
                            let newItems = container.innerHTML;
                            let currentContainer = document.getElementById('ceremony-container');
                            let existingHeaders = currentContainer.querySelectorAll('.date-group-header');
                            let lastHeader = existingHeaders.length > 0 ? existingHeaders[existingHeaders.length - 1] : null;
                            let lastDate = lastHeader ? lastHeader.getAttribute('data-date') : null;

                            let tempDiv = document.createElement("div");
                            tempDiv.innerHTML = newItems;

                            let firstNewHeader =
                                tempDiv.querySelector(".date-group-header");
                            if (
                                firstNewHeader &&
                                firstNewHeader.getAttribute("data-date") ===
                                    lastDate
                            ) {
                                firstNewHeader.remove();
                            }

                            currentContainer.insertAdjacentHTML(
                                "beforeend",
                                tempDiv.innerHTML,
                            );
                        }

                        let nextUrlElem = html.querySelector("#next_page_url");
                        nextPageUrlElem.value = nextUrlElem
                            ? nextUrlElem.value
                            : "";

                        ceremonyLoading = false;
                        loadingElem.style.display = "none";
                    });
            }
        }
    }
});


(function ($) {
'use strict';

var currentShareUrl = '';

function initSharePopup() {
    $(document).on('click', '.share-toggle', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var rawUrl   = $(this).data('url');
        var rawTitle = $(this).data('title');
        var rawMedia = $(this).data('media');
        var rawName  = $(this).data('name');

        currentShareUrl = rawUrl;

        var $container = $('#goodshareContainer');
        $container.find('.share-btn').attr('data-url', rawUrl);
        $container.find('.share-btn').attr('data-title', rawTitle);
        $container.find('.share-btn').attr('data-media', rawMedia);
        $container.find('.share-btn').attr('data-name', rawName);

        $('#shareModalOverlay').fadeIn(200);
    });

    $(document).on('click', '.share-btn', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var social = $(this).data('social');
        var url    = $(this).attr('data-url')   || currentShareUrl || window.location.href;
        var title  = $(this).attr('data-title') || '';
        var name   = $(this).attr('data-name')  || '';
        var media  = $(this).attr('data-media') || '';
        var text   = title || name;
        var shareLink = '';

        switch (social) {
            case 'whatsapp':
                shareLink = 'https://api.whatsapp.com/send?text=' + encodeURIComponent(text + '\n' + url);
                break;
            case 'facebook':
                shareLink = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url) +
                    '&quote=' + encodeURIComponent(text);
                break;
            case 'telegram':
                shareLink = 'https://t.me/share/url?url=' + encodeURIComponent(url) +
                    '&text=' + encodeURIComponent(text);
                break;
            case 'twitter':
                shareLink = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(url) +
                    '&text=' + encodeURIComponent(text);
                break;
            case 'linkedin':
                shareLink = 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(url);
                break;
           case 'email':
    var gmailUrl = 'https://mail.google.com/mail/?view=cm&fs=1&su=' + encodeURIComponent(title) +
        '&body=' + encodeURIComponent(text + '\n' + url + (media ? '\n' + media : ''));
    window.open(gmailUrl, '_blank');
    return;
        }

        console.log('final share link:', shareLink);
        if (shareLink) {
            window.open(shareLink, '_blank', 'width=600,height=480');
        }
    });

    $(document).on('click', '#shareModalClose, #shareModalOverlay', function (e) {
        if (e.target === this) $('#shareModalOverlay').fadeOut(200);
    });
    $(document).on('click', '#shareCopyBtn', function (e) {
        e.preventDefault();
        navigator.clipboard.writeText(currentShareUrl).then(function () {
            $('#shareCopiedBar').fadeIn(200);
            setTimeout(function () { $('#shareCopiedBar').fadeOut(400); }, 2000);
        });
    });
}

$(document).ready(function () {
    initSharePopup();
});

})(jQuery);